exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-card[data-v-b0e3873e]{margin-top:2rem;border-radius:10px;box-shadow:0 8px 12px 0 rgba(0,0,0,.2)}.ant-card .card-title[data-v-b0e3873e]{font-weight:700;color:#3d3d3d;margin-bottom:2rem;padding-left:1rem}.ant-collapse[data-v-b0e3873e]{background:#fff;margin-bottom:1rem}.ant-collapse .ant-collapse-item[data-v-b0e3873e]{border-bottom:0}.collapse-panel[data-v-b0e3873e]{font-weight:500;font-size:1.5rem;color:#3d3d3d}[data-v-b0e3873e] .autocomplete__results{width:auto}.sub-title[data-v-b0e3873e]{color:#4a5568;font-weight:500;line-height:26px;font-size:1.2rem;display:inline-block}", ""]);

// exports
